import React from "react";
import { Fire, Medal } from "@phosphor-icons/react";

const TONE = { "Gold Streak": "#C5A059", "Silver Streak": "#D1D5DB", "Bronze Streak": "#CD7F32" };

export default function StreakBadge({ streak, className = "" }) {
  if (!streak) return null;
  const { current, best, badge, next_milestone: next } = streak;
  return (
    <div data-testid="streak-badge" className={`border border-exodus-border bg-exodus-bg/60 p-4 flex flex-wrap items-center gap-x-4 gap-y-3 ${className}`}>
      <Fire size={28} weight={current > 0 ? "fill" : "regular"} className={current > 0 ? "text-orange-400" : "text-exodus-muted"} />
      <div className="flex-1 min-w-[9rem]">
        <p className="text-sm whitespace-nowrap"><span data-testid="streak-current" className="font-display text-2xl gold-text mr-1">{current}</span> check-in streak</p>
        <p data-testid="streak-best" className="text-[11px] text-exodus-muted">
          Best: {best}{next ? ` · ${next - current} more to ${next}` : " · top milestone reached"}
        </p>
      </div>
      {badge && (
        <span data-testid="streak-milestone" className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest border px-2 py-1 shrink-0" style={{ color: TONE[badge], borderColor: TONE[badge] }}>
          <Medal size={12} weight="fill" /> {badge}
        </span>
      )}
    </div>
  );
}
